import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { getNowTime } from '@service/common';
import './style.scss';
import { Icon, Modal } from '@ss/mtd-react-mobile';
import { useRootStore } from '@model/index';
import { SECTION_NAME_MAP } from '@model/content';

export default (props) => {
  const { style } = props;
  const [visible, setVisible] = useState(false);
  const [nowYear, setNowYear] = useState('2022');
  const {
    cmsData: { getSectionByName },
  } = useRootStore();
  const focusList = getSectionByName(SECTION_NAME_MAP.focusList) || [];
  const [currentTab, setCurrentTab] = useState(focusList[0] || {});

  useEffect(() => {
    (async () => {
      const nowTime = await getNowTime();
      if (nowTime) {
        setNowYear(dayjs(nowTime as number).format('YYYY'));
      }
    })();
  }, []);
  return (
    <div style={style} className="zp_mobile_sub_footer">
      <Modal
        className="zp_mobile_sub_footer_modal"
        animation="fade"
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
      >
        <div className="zp_mobile_sub_footer_inner">
          <div className="zp_mobile_sub_footer_title">
            <div className="name">{currentTab.title}</div>
            <div className="close_icon">
              <Icon
                type="close"
                onClick={() => {
                  setVisible(false);
                }}
              />
            </div>
          </div>
          <div className="center_img">
            <img src={currentTab.imgUrl} alt="code" />
          </div>
          <div className="text_wrapper">
            <div>{currentTab.secondTitle}</div>
            {/* {currentTab.subText ? <div>{currentTab.subText}</div> : null} */}
          </div>
        </div>
      </Modal>
      <div className="zp_mobile_sub_footer_img_wrap">
        {focusList.map((item, index) => {
          return (
            <div
              className="zp_mobile_sub_footer_img"
              key={index}
              onClick={() => {
                setCurrentTab(focusList[index]);
                setVisible(true);
              }}
            >
              <img src={item.icon} alt="share" />
            </div>
          );
        })}
      </div>
      <div className="zp_mobile_sub_footer_text">一起成长，一起更好</div>
      <div className="zp_mobile_sub_footer_sub_text">Grow Together, Better Together</div>
      <div className="zp_mobile_sub_footer_slogon_wrap">
        <img src="//s3plus.meituan.net/zhaopin-official-website-mobile-prod/common/logo.png" alt="logo" />
      </div>
      <div className="zp_mobile_sub_footer_banquan">
        <div className="copyText">
          <div>
            <span>
              <a className="meituanUrl" href="https://www.meituan.com">
                美团
              </a>
            </span>
            &nbsp;&nbsp;
            {/* <span className="line">|</span> */}
            <span className="meituanCopy">@{nowYear} 美团版权所有</span>
          </div>
          <div className="numWrap">
            <span>
              <a className="num1" href="https://beian.miit.gov.cn/">
                京ICP备10211739号
              </a>
            </span>
            <span className="num2Wrap">
              <i className="icon" />
              <a className="num2" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002002052">
                京公网安备 11000002002052号
              </a>
            </span>
          </div>
          <div>
            <span>
              <a className="rule" href="https://rules-center.meituan.com/m/detail/guize/2">
                隐私政策
              </a>
            </span>
          </div>
          {/* <span className="contact">&nbsp;&nbsp;&nbsp;&nbsp;招聘意见反馈：zhaopin@meituan.com</span> */}
        </div>
        {/* {`@${nowYear} 美团 版权所有`} */}
      </div>
    </div>
  );
};
